<template>
  <v-dialog
    v-model="display"
    persistent
    content-class="v-dialog-form-bottom"
    transition="dialog-bottom-transition"
  >
    <v-card flat>
      <v-card-title
        class="py-3 mb-6 justify-space-between"
        style="border-bottom: 1px solid #D3D2D2"
      >
        <div style="width:28px"></div>
        <span class="font-weight-bold">{{ title }}</span>
        <v-btn
          icon
          small
          @click="display = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        class="ma-0 pa-1"
      >
        <v-list flat>
          <v-list-item-group
          >
            <!-- City -->
            <v-list-item>
              <v-list-item-content>
                <v-text-field
                  label="City"
                  v-model="city"
                  @keyup="changeCity"
                  :rules="[rules.over3]"
                  placeholder="Please input your city in English."
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
            <!-- SelectList -->
            <v-list-item
              v-for="(item, i) in selectList"
              :key="i"
              @click.stop="selectItem(item)"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-html="`${item.name}, ${item.region}, ${item.countryFlag}`"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import service from '@/plugins/service'

export default {
  data: () => ({
    title: '',
    display: false,
    city: '',
    selectList: [],
    rules: {
      over3: value => (value || '').length > 2 || 'Please input at least 3 characters.',
    },
  }),
  methods: {
    show(title) {
      if (this.display) {
        return
      }
      this.title = title
      this.city = ''
      this.selectList.length = 0
      this.display = true
    },
    selectItem(item) {
      const result = {
        city: item.city,
        cityId: item.id,
        latitude: item.latitude,
        longitude: item.longitude,
        region: item.region,
        regionCode: item.regionCode,
        country: item.country,
        countryCode: item.countryCode,
      }
      service.log(result)
      this.$emit('change', result)
      this.display = false
    },
    async changeCity() {
      if (this.city && this.city.length > 2) {
        const list = await service.getCityListFromCityPrefix(this.city)
        this.selectList.length = 0
        if (Array.isArray(list)) {
          list.forEach(o => {
            o.countryFlag = service.getFlagCode(o.countryCode)
            this.selectList.push(o)
          })
        }
      }
    },
  },
};
</script>
